export function tradingOrderStatusMap(status: string): string {
  if (status.toLowerCase().includes("canceled")) {
    return "Canceled";
  }

  const statusMap: Record<string, string> = {
    open: "Open",
    filled: "Filled",
    triggered: "Triggered",
    rejected: "Rejected",
  };

  return statusMap[status] || status;
}
